/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  registerText: {
    id: "RegisterPage.registerText",
    defaultMessage: "Please enter a valid e-mail address and the password for your account.",
  },
  registerButton: {
    id: "RegisterPage.registerButton",
    defaultMessage: "Back to Login",
  },
  registerMailError: {
    id: "RegisterMail.error",
    defaultMessage: "E-mail is required.",
  },
  registerMail: {
    id: "RegisterMail.name",
    defaultMessage: "E-mail",
  },
  registerPwError: {
    id: "RegisterPw.error",
    defaultMessage: "The password must meet at least 2 out of 3 of the following conditions: Letters (eg ABCD ...) - Numbers (eg 0123 ...) - Special characters (eg # $% ...)",
  },
  registerPw: {
    id: "RegisterPw.name",
    defaultMessage: "Password",
  },
  registerPwRepeatError: {
    id: "RegisterPwRepeat.error",
    defaultMessage: "Passwords doesn\'t match.",
  },
  registerPwRepeat: {
    id: "RegisterPwRepeat.name",
    defaultMessage: "Repeat password",
  },
  registerUserGenderError: {
    id: "RegisterUserGender.error",
    defaultMessage: "Salutation is required",
  },
  registerUserGender: {
    id: "RegisterUserGender.label",
    defaultMessage: "Salutation",
  },
  registerUserGenderMr: {
    id: "RegisterUserGender.mr",
    defaultMessage: "Mr.",
  },
  registerUserGenderMrs: {
    id: "RegisterUserGender.mrs",
    defaultMessage: "Mrs.",
  },
  registerUserFirstNameError: {
    id: "registerUserFirstName.error",
    defaultMessage: "First name is required and should contain at least 2 characters.",
  },
  registerUserFirstName: {
    id: "registerUserFirstName.label",
    defaultMessage: "First name",
  },
  registerUserLastNameError: {
    id: "registerUserLastName.error",
    defaultMessage: "Last name is required and should contain at least 2 characters.",
  },
  registerUserLastName: {
    id: "registerUserLastName.label",
    defaultMessage: "Last name",
  },
  registerUserPhone: {
    id: "registerUserPhone.label",
    defaultMessage: "Phone",
  },
  registerUserMobile: {
    id: "registerUserMobile.label",
    defaultMessage: "Mobile",
  },
  registerUserCompany: {
    id: "registerUserCompany.label",
    defaultMessage: "Company",
  },
  registerUserStreetError: {
    id: "registerUserStreet.error",
    defaultMessage: "Street is required and should contain at least 2 characters.",
  },
  registerUserStreet: {
    id: "registerUserStreet.label",
    defaultMessage: "Street",
  },
  registerUserHouseError: {
    id: "registerUserHouse.error",
    defaultMessage: "House number is required and should contain at least 1 character.",
  },
  registerUserHouse: {
    id: "registerUserHouse.label",
    defaultMessage: "House number",
  },
  registerUserZipError: {
    id: "registerUserZip.error",
    defaultMessage: "Zip is required and should contain at least 2 characters.",
  },
  registerUserZip: {
    id: "registerUserZip.label",
    defaultMessage: "Zip number",
  },
  registerUserCityError: {
    id: "registerUserCity.error",
    defaultMessage: "City is required and should contain at least 2 characters.",
  },
  registerUserCity: {
    id: "registerUserCity.label",
    defaultMessage: "City",
  },
  registerUserAddressAdditional: {
    id: "registerUserAddressAdditional.label",
    defaultMessage: "Address additional",
  },
  registerUserCountryError: {
    id: "registerUserCountry.error",
    defaultMessage: "Country is required.",
  },
  registerUserCountry: {
    id: "registerUserCountry.label",
    defaultMessage: "Country",
  },
  registerUserCountryLabel: {
    id: "registerUserCountryLabel.label",
    defaultMessage: "Choose country",
  },
  registerUserClientNr: {
    id: "registerUserClientNr.label",
    defaultMessage: "Client number (if available)",
  },
  registerUserBranchError: {
    id: "registerUserBranch.error",
    defaultMessage: "Branch is required",
  },
  registerUserBranch: {
    id: "registerUserBranch.label",
    defaultMessage: "Branch",
  },
  registerUserSanitary: {
    id: "registerUserBranchSanitary.label",
    defaultMessage: "Sanitary wholesale",
  },
  registerUserPlanner: {
    id: "registerUserBranchPlanner.label",
    defaultMessage: "Planner / Architect",
  },
  registerUserPlumber: {
    id: "registerUserBranchPlumber.label",
    defaultMessage: "Plumber",
  },
  registerUserRetail: {
    id: "registerUserBranchRetail.label",
    defaultMessage: "Retail customer",
  },
  editUserGenderError: {
    id: "editUserGender.error",
    defaultMessage: "Salutation is required",
  },
  editUserGender: {
    id: "editUserGender.label",
    defaultMessage: "Salutation",
  },
  editUserGenderMr: {
    id: "editUserGenderMr.label",
    defaultMessage: "Mr.",
  },
  editUserGenderMrs: {
    id: "editUserGenderMrs.label",
    defaultMessage: "Mrs.",
  },
  editUserFirstNameError: {
    id: "editUserFirstName.error",
    defaultMessage: "First name is required and should contain at least 2 characters.",
  },
  editUserFirstName: {
    id: "editUserFirstName.label",
    defaultMessage: "First name",
  },
  editUserLastNameError: {
    id: "editUserLastName.error",
    defaultMessage: "Last name is required and should contain at least 2 characters.",
  },
  editUserLastName: {
    id: "editUserLastName.label",
    defaultMessage: "Last name",
  },
  editUserPhone: {
    id: "editUserPhone.label",
    defaultMessage: "Phone",
  },
  editUserMobile: {
    id: "editUserMobile.label",
    defaultMessage: "Mobile",
  },
  editUserStreetError: {
    id: "editUserStreet.error",
    defaultMessage: "Street is required and should contain at least 2 characters.",
  },
  editUserStreet: {
    id: "editUserStreet.label",
    defaultMessage: "Street",
  },
  editUserHouseError: {
    id: "editUserHouse.error",
    defaultMessage: "House number is required and should contain at least 1 character.",
  },
  editUserHouse: {
    id: "editUserHouse.label",
    defaultMessage: "House number",
  },
  editUserAddressAdditional: {
    id: "editUserAddressAdditional.label",
    defaultMessage: "Address additional",
  },
  editUserZipError: {
    id: "editUserZip.error",
    defaultMessage: "Zip is required and should contain at least 2 characters.",
  },
  editUserZip: {
    id: "editUserZip.label",
    defaultMessage: "Zip",
  },
  editUserCityError: {
    id: "editUserCity.error",
    defaultMessage: "City is required and should contain at least 2 characters.",
  },
  editUserCity: {
    id: "editUserCity.label",
    defaultMessage: "City",
  },
  editUserCountryError: {
    id: "editUserCountry.error",
    defaultMessage: "Country is required.",
  },
  editUserCountry: {
    id: "editUserCountry.label",
    defaultMessage: "Country",
  },
  editUserCountryLabel: {
    id: "editUserCountryLabel.label",
    defaultMessage: "Choose country",
  },
});

export default MESSAGES;